import { useAuthStore } from "@/store/useAuthStore";

const isDisabled = () =>
  useAuthStore.getState().user?.config?.disableDebugLogs === true;

export const debugLog = (...args) => {
  if (!isDisabled()) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (!isDisabled()) {
    console.warn(...args);
  }
};

export const debugDebug = (...args) => {
  if (!isDisabled()) {
    console.debug(...args);
  }
};
